// removed by extract-text-webpack-plugin
module.exports = {"select-days-in-month":"select-days-in-month","select-list":"select-list","select-day":"select-day","selected":"selected"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/SelectDaysInMonth/SelectDaysInMonthField.scss
// module id = JWQK
// module chunks = 0